import React from 'react';
import './ConfirmPopup.css';

/**
 * Popup de confirmación con dos botones (cancelar / confirmar).
 * Si cancelLabel es null/false, se muestra solo el botón de confirmar (modo alerta).
 * @param {boolean} open - Si está visible
 * @param {string} title - Título del popup
 * @param {string} message - Mensaje o pregunta
 * @param {string} confirmLabel - Texto del botón confirmar (ej. "Darme de baja")
 * @param {string|null} cancelLabel - Texto del botón cancelar; null/false oculta cancelar
 * @param {function} onConfirm - Al hacer clic en confirmar
 * @param {function} onCancel - Al hacer clic en cancelar o en el overlay
 * @param {string} variant - 'danger' (botón rojo) o 'primary' (por defecto)
 */
const ConfirmPopup = ({
  open,
  title = 'Confirmar',
  message = '',
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  onConfirm,
  onCancel,
  variant = 'primary',
}) => {
  if (!open) return null;

  const showCancel = cancelLabel != null && cancelLabel !== false;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onCancel?.();
  };

  return (
    <div
      className="confirm-popup-overlay"
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-popup-title"
      aria-describedby="confirm-popup-desc"
    >
      <div className="confirm-popup-box" onClick={(e) => e.stopPropagation()}>
        <h3 id="confirm-popup-title" className="confirm-popup-title">{title}</h3>
        <p id="confirm-popup-desc" className="confirm-popup-message">{message}</p>
        <div className="confirm-popup-actions">
          {showCancel && (
            <button
              type="button"
              className="confirm-popup-btn confirm-popup-btn-cancel"
              onClick={onCancel}
              aria-label={cancelLabel}
            >
              {cancelLabel}
            </button>
          )}
          <button
            type="button"
            className={`confirm-popup-btn confirm-popup-btn-confirm confirm-popup-btn-${variant}`}
            onClick={onConfirm}
            aria-label={confirmLabel}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
